import type { NavigationItem } from '@src/lib/graphql/generated';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { PropsWithChildren, ReactNode } from 'react';

export type NavigationClassProps = PropsWithClassProps<'heading' | 'list' | 'listItem' | 'link'>;

export interface NavigationProps extends NavigationClassProps, PropsWithChildren {
  items: NavigationItem[];
  renderLink?: (Link, index: number) => ReactNode;
  title?: string;
  withHeading?: boolean;
}

export const Navigation = ({
  classProps,
  items,
  title = 'Navigation',
  withHeading = false,
  renderLink,
  children,
}: NavigationProps) => (
  <nav className={classProps?.root} aria-label={title}>
    {withHeading && <div className={classProps?.heading}>{title}</div>}
    {items && items.length > 0 && (
      <ul className={classProps?.list}>
        {items.map((link, index) => {
          const externalLink = !(link.url.includes('tv-media') || link.url.startsWith('/'));

          return (
            <li key={index} className={classProps?.listItem}>
              {renderLink ? (
                renderLink(link || '', index)
              ) : (
                <a
                  href={link.slug || link.url || ''}
                  target={externalLink ? '_blank' : ''}
                  rel={externalLink ? 'noopener noreferrer' : ''}
                  className={classProps?.link}
                >
                  {link.title}
                </a>
              )}
            </li>
          );
        })}
        {children}
      </ul>
    )}
  </nav>
);
